/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { Button, Input, Select, Form, Space, Spin, Row, Col } from "antd";
import {
  AuditOutlined,
  BackwardOutlined,
  FormOutlined,
  PlusCircleTwoTone,
} from "@ant-design/icons";
import "../../../components/AdminComponents/contactStyles.css";
import Sidebar from "../../../components/AdminComponents/SideNav";
import {
  ClientMenu,
  SettingsMenu,
} from "../../../components/AdminComponents/MenuItems";
import { useParams, NavLink } from "react-router-dom";
import Axios from "../../../api/Axios";
import { message } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "react-phone-number-input/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useNavigate } from "react-router-dom";
import FormItem from "antd/es/form/FormItem";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
import { capitalizeWords } from "../../../components/icons/ApplicationColor";
const { Option } = Select;
const handleRowClick = () => {};
const record = null;
// eslint-disable-next-line no-lone-blocks
const EditUsers = () => {
  const history = useNavigate();
  const { id } = useParams();
  const phoneInputRef = useRef();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(true);
  const [rolesLoaded, setRolesLoaded] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [applications, setApplications] = useState([]);
  const [initialApplication, setInitialApplication] = useState([]);

  const [phone, setPhone] = useState();
  //console.log(phone);
  const [additionalFieldsCount, setAdditionalFieldsCount] = useState(1);
  const [roles1, setRoles1] = useState([]);
  const [formData, setFormData] = useState();
  const [newRoles, setNewRoles] = useState();
  //console.log(formData);
  //console.log(roles1);
  const [phoneObj, setPhoneObj] = useState(null);
  const [isUserIDExists, setIsUserIDExists] = useState(false);
  const [selectedApplications, setSelectedApplications] = useState([]);

  // const handleAppSelection = (value, index) => {
  //   setSelectedApplications((prevSelectedApplications) => {
  //     const updatedSelectedApplications = [...prevSelectedApplications];
  //     updatedSelectedApplications[index] = value;
  //     return updatedSelectedApplications;
  //   });
  // };
  const handleAppSelection = (value, index) => {
    //console.log(value, index);
    setSelectedApplications((prevSelectedApplications) => {
      const updatedSelectedApplications = [...prevSelectedApplications];
      updatedSelectedApplications[index] = value;
      return updatedSelectedApplications;
    });
    formRef.current.setFieldsValue({ [`user_role[${index}]`]: null });
    const selectedApp = applications.find((app) => app.id === value);
    //console.log(applications);
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      if (selectedApp) {
        // set the roles for the selected application
        updatedRoles[index] = selectedApp.roles;
      } else {
        updatedRoles[index] = [];
      }
      return updatedRoles;
    });
  };

  const resetAppAnduser = (ele) => {
    //console.log(ele, "--------------------");
    formRef.current.setFieldsValue({ [`user_role[${ele}]`]: null });
    formRef.current.setFieldsValue({ [`applications[${ele}]`]: null });
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      updatedRoles[ele] = [];
      return updatedRoles;
    });
  };

  const LoadApplications = async () => {
    try {
      const res = await Axios.get(`/globaluserroleaccess/`);
      //console.log(res.data);
      setApplications(res.data);
      setNewRoles(res.data);
      //console.log(res.data);
      //console.log(Math.min(res.data?.length || 0, 5));
      // setAdditionalFieldsCount(Math.min(res.data?.length || 0, 5));
      //console.log(additionalFieldsCount); // set maximum number of fields to 5 or the length of the data array, whichever is smaller
    } catch (err) {
      //console.log(err);
    }
  };

  const LoadData = async () => {
    try {
      const res = await Axios.get(`/user/${id}/`);
      //console.log(res.data);
      setFormData(res.data);
      setInitialApplication(res.data?.applications);
      setAdditionalFieldsCount(res.data?.applications?.length);
      // for (let i = 0; i < res.data.applications.length; i++) {
      //   formRef.current.setFieldsValue({
      //     [`applications[${i}]`]: res.data.applications[i].application.name,
      //   });
      //   formRef.current.setFieldsValue({
      //     [`user_role[${i}]`]: res.data.applications[i].role.name,
      //   });
      //   setRoles1((prevRoles) => {
      //     const updatedRoles = [...prevRoles];
      //     updatedRoles[i] = [res.data.applications[i].role];
      //     console.log(res.data.applications[i].role);
      //     // updatedRoles[0] = [{ id: 2, name: "Editor", key_name: "editor" }];
      //     // updatedRoles[1] = [{ id: 2, name: "admin", key_name: "editor" }];
      //     return updatedRoles;
      //   });
      // }
      setLoading(false);
      //console.log(loading);
    } catch (err) {
      //console.log(err);
    }
  };

  useEffect(() => {
    LoadApplications();
    LoadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);
  const accessRef = useRef(false);
  const applicationvalue = (index, values) => {
    if (values[`applications[${index}]`] === "Trak Learning") {
      return 1;
    } else if (values[`applications[${index}]`] === "DelegateHR") {
      return 3;
    } else if (values[`applications[${index}]`] === "Trak Coaching") {
      return 2;
    } else {
      return values[`applications[${index}]`];
    }
  };
  const rolevalue = (index, values) => {
    const value = values[`user_role[${index}]`];
    if (typeof value === "string" && value.length > 2) {
      return formData.applications[index].role.id;
    } else {
      return values[`user_role[${index}]`];
    }
  };
  const [removedRoleIds, setRemovedRoleIds] = useState([]);
  const onFinish = async (values) => {
    // Get the current role IDs set in the form
    const updatedRoles = [...values.roles, ...removedRoleIds];
    const updatedValues = {
      ...values,
      roles: updatedRoles,
    };

    const normalizedValues = Object.fromEntries(
      Object.entries(updatedValues).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    if (phone && phone.length > 4 && !phone.startsWith("+")) {
      updatedValues.phone_number = "+" + phone;
    } else if (phone && phone.length > 4 && phone.startsWith("+")) {
      updatedValues.phone_number = phone;
    } else {
      updatedValues.phone_number = "";
    }
    const finalValues = {
      ...normalizedValues,
    };

    //console.log("Form values:", finalValues);

    try {
      const res = await Axios.put(`/user/${id}/`, finalValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      CreateSuccessfull();
    } catch (err) {
      if (err?.response?.data?.detail?.phone_number) {
        CreateFailed(`${err?.response?.data?.detail?.phone_number}`);
      } else {
        CreateFailed("admin edit failed");
      }
      //console.log(err.response.data.detail);
    }
  };

  const CreateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Admin has been edited.",
      duration: 5,
    });
    // LoadContacts();
    setTimeout(() => {
      history("/access-manager/admins");
    }, 5000);
  };
  const handleAccessReset = (index) => {
    // setAdditionalFieldsCount(0);
    //console.log("-------------------------------");
    //console.log(additionalFieldsCount);
    formRef.current.setFieldsValue({ access: false });

    formRef.current.setFieldsValue({ [`user_role[${index}]`]: null });
    formRef.current.setFieldsValue({ [`applications[${index}]`]: null });
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      updatedRoles[index] = [];
      return updatedRoles;
    });
  };
  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `${props}`,
      duration: 5,
    });
  };
  const formRef = useRef();
  const handleSubmit = async (values) => {
    const applications = [];
    for (let i = 0; i < additionalFieldsCount; i++) {
      const application = {
        application: values[`applications[${i}]`],
        role: values[`user_role[${i}]`],
      };
      applications.push(application);
    }
    //console.log(applications);
  };

  const handleReset = () => {
    formRef.current.resetFields();
  };
  useEffect(() => {
    //console.log(additionalFieldsCount);
    //console.log(roles1);
  }, [additionalFieldsCount, roles1]);
  useEffect(() => {
    // Only update the Select components once the roles1 state has been updated
    setRolesLoaded(true);
  }, [roles1]);
  useEffect(() => {
    // const rolesToSet = formData.roles.filter((role) =>
    //   newRoles.some((newRole) => newRole.id === role.id)
    // );
    // const rolesToSet = formData?.roles.map((app) => app.id);
    const rolesToSetIds = formData?.roles
      .filter((role) => newRoles.some((newRole) => newRole.id === role.id))
      .map((role) => role.id);

    //console.log(rolesToSetIds);
    const removedRoles = formData?.roles
      .map((role) => role.id)
      .filter((roleId) => !rolesToSetIds.includes(roleId));

    setRemovedRoleIds(removedRoles);
    if (!loading && formRef.current) {
      formRef.current.setFieldsValue({
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        status: formData.status,
        user_id: formData.user_id,
        phone_number:
          formData.phone_number === null || formData.phone_number === ""
            ? "+1"
            : formData.phone_number,
        roles: rolesToSetIds,
      });
      setPhone(formData.phone_number);
    }
  }, [loading, formData, newRoles]);
  const handleFormChange = async (changedValues, allValues) => {
    //console.log(formData.email);
    if ("email" in changedValues && allValues.email.length > 3) {
      if ("email" in changedValues && allValues.email === formData?.email) {
        setIsUserIDExists(false);
      } else {
        const response = await Axios.get(
          `/usercheck/?search=${allValues.email}`
        );
        //console.log(response);
        setIsUserIDExists(response.data.exists);
      }
    }
    // if ("naics_primary" in changedValues && allValues.naics_primary.length > 3) {
    //   const response = await Axios.get(
    //     `/naicslist/?search=${allValues.naics_primary}`
    //   );
    //   console.log(response);
    //   setNaicsRes(response.data);
    // }
  };
  const [countryCode, setCountryCode] = useState("");
  const handlePhoneNumberChange = (value, data, event, formattedValue) => {
    //console.log(data);
    setCountryCode(data.dialCode);
    setPhone(value);
  };
  const checkUserIDExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserIDExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserIDExists().then(resolve, reject);
        }, 100);
      } else if (isUserIDExists) {
        reject("Email ID already exists");
      } else {
        resolve();
      }
    });
  };
  const thirdMenuData = [
    {
      path: `/access-manager/admins/edit-user/${id}`,
      name: "Edit Admin",
      icon: (
        <PlusCircleTwoTone
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
  ];
  return (
    <div>
      <Sidebar props={SettingsMenu}>
        {contextHolder}
        <SecondaryNav menuItems={thirdMenuData} />
        <div className="form-container-2">
          <Spin spinning={loading}>
            <Form
              name="complex-form"
              onFinish={onFinish}
              layout="vertical"
              initialValues={formData}
              onValuesChange={handleFormChange}
              ref={formRef}
              labelCol={{
                span: 25,
              }}
              wrapperCol={{
                span: 80,
              }}
              style={{
                width: "100%",
                marginBottom: "150px",
              }}
            >
              <div className="group1">
                <div className="form-heading">
                  {capitalizeWords("EDIT ADMIN INFO")}
                </div>
                <div className="antd-test-client" style={{ marginTop: "3rem" }}>
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">First Name</p>}
                      >
                        <Form.Item
                          name="first_name"
                          noStyle
                          rules={[
                            { required: true, message: "Username is required" },
                          ]}
                          initialValue={formData?.first_name}
                        >
                          <Input
                            className="my-form-input-antd-test"
                            placeholder={"Enter user name"}
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Last Name</p>}
                      >
                        <Form.Item
                          name="last_name"
                          noStyle
                          initialValue={formData?.last_name}
                        >
                          <Input
                            placeholder="Enter last name"
                            className="my-form-input-antd-test"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={6} xl={6}>
                      <Form.Item
                        label={<p className="my-form-lables">Email</p>}
                      >
                        <Form.Item
                          name="email"
                          noStyle
                          rules={[
                            {
                              message: "Enter a valid email",
                              type: "email",
                            },
                            {
                              validator: checkUserIDExists,
                              validateTrigger: "onChange",
                            },
                          ]}
                          initialValue={formData?.email}
                        >
                          <Input
                            placeholder="Enter Email"
                            className="my-form-input-antd-test"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
                <div className="antd-test-client">
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <div
                      style={{ display: "inline-block", marginLeft: "1rem" }}
                    >
                      <Form.Item
                        label={<p className="my-form-lables">Phone No.</p>}
                      >
                        <Space>
                          <Form.Item noStyle name="phone_number">
                            <PhoneInput
                              // className="my-form-input"
                              ref={phoneInputRef}
                              placeholder="Enter your Phone No."
                              defaultCountry="US"
                              value={phone}
                              // style={{ width: "26rem" }}
                              onChange={handlePhoneNumberChange}
                              onBlur={() => {
                                try {
                                  const phoneObj =
                                    parsePhoneNumberFromString(phone);
                                  setPhoneObj(phoneObj);
                                } catch (e) {
                                  setPhoneObj(null);
                                }
                              }}
                            />
                          </Form.Item>
                        </Space>
                      </Form.Item>
                    </div>

                    <Col xs={24} sm={12} md={3} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Status</p>}
                      >
                        <Input.Group compact>
                          <Form.Item
                            name="status"
                            noStyle
                            initialValue={formData?.status}
                          >
                            <Select
                              placeholder="Select Status"
                              className="my-form-input-antd-test"
                            >
                              <Option value={true}>Active</Option>
                              <Option value={false}>Inactive</Option>
                            </Select>
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">User ID</p>}
                      >
                        <Form.Item
                          name="user_id"
                          noStyle
                          initialValue={formData?.user_id}
                          rules={[
                            { required: true, message: "User ID is required" },
                          ]}
                        >
                          <Input
                            className="my-form-input-antd-test"
                            placeholder="Enter user ID"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>

                {true && (
                  // <div className="group-1-box" style={{ marginTop: "2rem" }}>
                  <div className="antd-test-client">
                    <Row gutter={20} style={{ marginLeft: "2rem" }}>
                      <Col xs={24} sm={12} md={10} lg={6} xl={6}>
                        <Form.Item
                          label={<p className="my-form-lables">Roles</p>}
                        >
                          <Form.Item name="roles" noStyle initialValue={[]}>
                            <Select
                              placeholder="Select Roles"
                              className="my-form-input-antd-test"
                              mode="multiple"
                              // onChange={handleRoleSelection}
                            >
                              {newRoles?.map((role) => (
                                <Option key={role.id} value={role.id}>
                                  {role.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
              <div style={{ display: "inline-block", marginLeft: "5rem" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    style={{
                      background: "#D3D3D3",
                    }}
                    onClick={() => {
                      history("/access-manager/admins");
                    }}
                  >
                    <BackwardOutlined />
                    Back
                  </Button>
                </Form.Item>
              </div>

              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </Form.Item>
              </div>
              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    // className="my-form-input-end"
                    style={{
                      background: "#f58029",
                      fontWeight: "600",
                    }}
                    className="save-update-btn"
                  >
                    Update
                    <FormOutlined />
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </Spin>
        </div>
      </Sidebar>
    </div>
  );
};

export default EditUsers;
